module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "spinner"
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', [_vm._v("Loading...")])]) : _vm._e(), _vm._v(" "), _c('form', [_c('div', {
    staticClass: "p-grid justify-content-end"
  }, [_c('div', {
    staticClass: "p-col"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success addNewBtn btn-btm-0",
    attrs: {
      "icon": "pi pi-plus",
      "label": "NEW"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openAddDialog.apply(null, arguments)
      }
    }
  })], 1)]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Clinet Details",
      "visible": _vm.addDisplayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.addDisplayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": _vm.editing ? 'Update' : 'Add'
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCustomer.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.addCancel.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "name"
    },
    model: {
      value: (_vm.clientName),
      callback: function($$v) {
        _vm.clientName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "clientName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "primaryContactNumber"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "primaryContactNumber"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.primaryContactNumber),
      callback: function($$v) {
        _vm.primaryContactNumber = $$v
      },
      expression: "primaryContactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "sec"
    }
  }, [_vm._v("Secondary Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "sec"
    },
    model: {
      value: (_vm.secondaryContactNumber),
      callback: function($$v) {
        _vm.secondaryContactNumber = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "secondaryContactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "email"
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "product"
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "product"
    },
    model: {
      value: (_vm.product),
      callback: function($$v) {
        _vm.product = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "product"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "product"
    }
  }, [_vm._v("Agreement Amount")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "product"
    },
    model: {
      value: (_vm.product),
      callback: function($$v) {
        _vm.product = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "product"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "product"
    }
  }, [_vm._v("Agreement Date")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "product"
    },
    model: {
      value: (_vm.product),
      callback: function($$v) {
        _vm.product = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "product"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Status")]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status1",
      "name": "ACTIVE",
      "value": "ACTIVE"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Active")]), _vm._v(" "), _c('RadioButton', {
    attrs: {
      "id": "status2",
      "name": "INACTIVE",
      "value": "INACTIVE"
    },
    model: {
      value: (_vm.status),
      callback: function($$v) {
        _vm.status = $$v
      },
      expression: "status"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status2"
    }
  }, [_vm._v("Inactive")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.description),
      expression: "description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('Button', {
    staticClass: "p-button-raised",
    attrs: {
      "label": "Contact Details"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.editPersonalInfo()
      }
    }
  })], 1)])]), _vm._v(" "), _c('Dialogs', {
    style: ({
      width: '50vw'
    }),
    attrs: {
      "header": "Clinet Contact Details",
      "visible": _vm.addPersonalDisplayBasic,
      "modal": true,
      "closable": false,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.addPersonalDisplayBasic = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('Button', {
          staticClass: "p-button-raised",
          attrs: {
            "label": "Save"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.closeAddPersonalInfoDialog.apply(null, arguments)
            }
          }
        }), _vm._v(" "), _c('Button', {
          staticClass: "p-button-raised p-button-danger",
          attrs: {
            "label": "Cancel"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.cancelAddPersonalInfoDialog.apply(null, arguments)
            }
          }
        })]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "contactName"
    }
  }, [_vm._v("Name"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactName"
    },
    model: {
      value: (_vm.contactName),
      callback: function($$v) {
        _vm.contactName = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address"), _c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")])]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactAddress"
    },
    model: {
      value: (_vm.contactAddress),
      callback: function($$v) {
        _vm.contactAddress = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactAddress"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "contactPrimaryContactNumber"
    }
  }, [_vm._v("Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactPrimaryContactNumber"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.contactPrimaryContactNumber),
      callback: function($$v) {
        _vm.contactPrimaryContactNumber = $$v
      },
      expression: "contactPrimaryContactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "conSec"
    }
  }, [_vm._v("secondary Contact Number")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "conSec"
    },
    on: {
      "keypress": function($event) {
        return _vm.isNumber($event)
      }
    },
    model: {
      value: (_vm.contactSecondaryContactNumber),
      callback: function($$v) {
        _vm.contactSecondaryContactNumber = $$v
      },
      expression: "contactSecondaryContactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "contactEmail"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "contactEmail"
    },
    model: {
      value: (_vm.contactEmail),
      callback: function($$v) {
        _vm.contactEmail = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "contactEmail"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "designation"
    }
  }, [_vm._v("Designation")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "designationId"
    },
    model: {
      value: (_vm.designationId),
      callback: function($$v) {
        _vm.designationId = (typeof $$v === 'string' ? $$v.trim() : $$v)
      },
      expression: "designationId"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    attrs: {
      "for": "conDescription"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.contactDescription),
      expression: "contactDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "rows": "2"
    },
    domProps: {
      "value": (_vm.contactDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.contactDescription = $event.target.value
      }
    }
  })])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-088121db"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/crmDialog/crmCustomerdialog.vue
// module id = 2022
// module chunks = 0